import { Checkbox, Switch, Select } from "antd";
import { LuPencil } from "react-icons/lu";

import { Card } from "reactstrap";
import { EditShippingAddressModal } from "../modals/EditAddressModal";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useState } from "react";

const OrderShippingAddressCard = ({
  title,
  shippingData,
  setShippingData,
  shippingCheckboxes,
  setShippingCheckboxes,
  handleShippingCheckboxChange,
  sameAsBilling,
  setSameAsBilling,
  tm,
  setTm,
  customer_acc,
  setCustomerAcc,
  saleOrder,
  setOrderNotes,
  order,
  usAddresses,
  selectedUSAddressId,
  setSelectedUSAddressId,
}) => {
  const { user } = useSelector((state) => state.auth);
  const { pathname } = useLocation();
  const route = pathname.split("/");

  const [editShippingModal, setEditShippingModal] = useState(false);
  const toggleShippingModal = () => setEditShippingModal(!editShippingModal);
  const handleShippingEdit = () => {
    toggleShippingModal();
  };
  const handleShippingSave = (updatedData) => {
    setShippingData(updatedData);
    toggleShippingModal();
    if (saleOrder && order?._id) {
      setOrderNotes([
        ...order?.logs,
        {
          createdAt: Date.now(),
          createdBy: user,
          message: `Shipping Details of ${order?.id} Order Updated Successfully by ${user?.username}`,
        },
      ]);
    }
  };
  const onSave = (updatedData) => {
    setShippingData(updatedData);
    toggleShippingModal();
  };
  const handleCheckboxChange = (key, checked) => {
    const updatedCheckboxes = { ...shippingCheckboxes, [key]: checked };
    setShippingCheckboxes(updatedCheckboxes);
  };
  return (
    <>
      <EditShippingAddressModal
        modal={editShippingModal}
        toggle={toggleShippingModal}
        shippingData={shippingData}
        setShippingData={setShippingData}
        onSave={onSave}
        handleShippingSave={handleShippingSave}
      />
      <Card className="border-1 h-100 rounded-0 bg-light p-2 my-2 my-lg-0 billingShippingCard">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="primary-color">{title}</h5>

          {(route.includes("sale-order-details") ||
            route.includes("new-quote") ||
            route.includes("manual-quote") ||
            route.includes("return-order-details") ||
            route.includes("update-purchase-orders-details")) && (
              <LuPencil className="pointer" onClick={handleShippingEdit} />
            )}
        </div>

        {shippingData && Object.keys(shippingData).length > 0 ? (
          <div className="fs-16">
            <p className="mb-0">{shippingData?.company ?? "Not given"}</p>
            <p className="mb-0">
              {shippingData?.first_name ?? ""} {shippingData?.last_name ?? ""}
            </p>
            <p className="mb-0">{shippingData?.address_1 ?? ""}</p>
            <p className="mb-0">{shippingData?.address_2 ?? ""}</p>
            <p className="mb-0">
              {shippingData?.city ?? ""} {shippingData?.state ?? ""}{" "}
              {shippingData?.postcode ?? ""}
            </p>
            <p className="mb-0">
              Ph:{" "}
              <span className="primary-color">{shippingData?.phone ?? ""}</span>
            </p>
            <p className="mb-0 primary-color">{shippingData?.email ?? ""}</p>
            {route.includes("sale-order-details") && (
              <>
                <Checkbox
                  checked={shippingCheckboxes?.sms_disabled}
                  onChange={(e) =>
                    handleCheckboxChange("sms_disabled", e.target.checked)
                  }
                >
                  SMS Disabled
                </Checkbox>
                <Checkbox
                  checked={shippingCheckboxes?.residiential}
                  onChange={(e) =>
                    handleCheckboxChange("residiential", e.target.checked)
                  }
                >
                  Residential
                </Checkbox>
              </>
            )}
            {title === "Ship to" && (
              <Checkbox
                checked={shippingCheckboxes?.ship_partially}
                onChange={(e) =>
                  handleCheckboxChange("ship_partially", e.target.checked)
                }
              >
                Ship Partially
              </Checkbox>
            )}

            {(route.includes("purchase-orders-details") ||
              route.includes("return-order-details")) && (
                <>
                <div className="d-flex align-items-center gap-3 mt-3">
                  <p className="mb-0 fw-bold">Coming to US</p>
                  <Switch
                    checked={tm}
                    onChange={(e) => {
                      setTm(e);
                    }}
                  />
                </div>
                {tm && usAddresses?.length > 0 && (
                  <div className="mt-2">
                    <Select
                      size="middle"
                      className="w-100"
                      value={selectedUSAddressId}
                      onChange={(val) => setSelectedUSAddressId && setSelectedUSAddressId(val)}
                      options={usAddresses.map(addr => ({
                        value: addr._id || addr.id,
                        label: `${addr.company} - ${addr.city}, ${addr.state}`
                      }))}
                    />
                  </div>
                )}
                </>
              )}
          </div>
        ) : (
          <p className="text-danger">Please Provide Shipping Details</p>
        )}
        {route.includes("manual-quote") && (
          <div className="d-flex gap-3">
            <Checkbox
              checked={sameAsBilling}
              onChange={handleShippingCheckboxChange}
            />
            <p className="mb-0">Same as Billing</p>
          </div>
        )}
      </Card>
    </>
  );
};
export default OrderShippingAddressCard;
